import React, { useEffect, useState } from "react";
import { priceFormat } from "@/utils/common";
import { renderCouponLabel } from "../renderCouponLabel";
import { renderSecKillCountDown } from "../renderSecKillCountDown";
import { GoodsItem } from "@/pages/charge-vip/types";
import { Image } from "@xp-design/mobile";
import { processDescText } from "../../utils";
import SoldOutPng from "@/assets/sold_out_3x.png";

import "./index.less";
import { processOssImage } from "@/utils/image";

export interface SmallGoodsItemProps {
  goodItem: GoodsItem;
  active: GoodsItem | null;
  activeChange: (item: GoodsItem, index: number) => void;
  index: number;
  isSeckill: boolean;
  countdown: string;
  showTriangle?: boolean;
  isDiscount: boolean;
}

export const SmallGoodsItem: React.FC<SmallGoodsItemProps> = ({
  goodItem,
  active,
  activeChange,
  index,
  isSeckill,
  countdown,
  showTriangle = false,
  isDiscount,
}) => {
  const [imageSrc, setImageSrc] = useState("");

  useEffect(() => {
    if (
      goodItem?.skuId === active?.skuId &&
      goodItem?.discountType === "SECONDS_KILL_PRICE"
    ) {
      // 生成一个10位的随机数，防止图片缓存
      const random = Math.floor(Math.random() * 1000000000);
      // 当有多个该组件时同时存在激活动效时，同一个图片路径导致动图无法渲染，通过加时间戳和随机数解决
      const url = `https://s.xiaopeng.com/xp-charge/charge/charge-vip/seckill-img.gif?${new Date().getTime()}-${random}`;
      setImageSrc(url); // 设置图片的路径
    } else {
      setImageSrc(""); // 清空图片路径
    }
  }, [active, goodItem?.discountType, goodItem?.skuId]);
  return (
    <div
      className={`good-item
        small-good-item
        ${goodItem?.skuId === active?.skuId ? "active" : ""}
        ${goodItem?.soldOut ? "sold-out" : ""}
      `}
      onClick={() => activeChange(goodItem, index)}
      key={`good-${goodItem?.skuId}-${index}`}
    >
      {!goodItem?.soldOut && renderCouponLabel({
        couponLabel: goodItem?.actDiscountLabel,
        discountType: goodItem?.discountType,
        isActive: goodItem?.skuId === active?.skuId,
      })}
      {imageSrc && !goodItem?.soldOut ? (
        <Image
          className={`seckillwebp-img`}
          src={imageSrc ? processOssImage(imageSrc) : ""}
          alt=""
          fallback={null}
          placeholder={null}
        />
      ) : null}
      <>
        <div className="good-title-wrap">{goodItem?.name || "--"}</div>
        <div
          className="good-price-wrap"
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 0,
          }}
        >
          <div className="good-price">
            <div className="big-heavy-text-unit">¥</div>
            <div className="big-heavy-text">
              {priceFormat(
                isDiscount ? goodItem?.discountBuyPrice : goodItem?.salePrice,
              )}
            </div>
          </div>
          <div className="good-desc-content">
            <div className="grey-line-price-text">
              {isDiscount && (
                <>
                  {"¥"}
                  {priceFormat(goodItem?.salePrice)}
                </>
              )}
            </div>
            <div className="good-extra-wrap">
              {processDescText(goodItem?.desc).map((line: string, idx: number, array) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < array.length - 1 && <br />}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </>
      {renderSecKillCountDown({
        countdown,
        isSeckill,
        isActive: goodItem?.skuId === active?.skuId,
      })}

      {showTriangle &&
        goodItem?.skuId === active?.skuId &&
        goodItem.customPicture && <div className={`introduce-icon ${goodItem?.soldOut ? "sold-out" : ""}`} />}
      {goodItem?.soldOut && (
        <img src={SoldOutPng} className="sold-out-icon" alt="售罄" />
      )}
    </div>
  );
};
